import axios from 'axios';

export default function shareTo(wireId, source, medium) {
  return axios.get(
    `/api/v1/wire/${wireId}/share/source/${source}/medium/${medium}`,
    { cache: { ignoreCache: true } },
  );
}
